/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
import { Link } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SearchIcon from '@mui/icons-material/Search';
import WindowIcon from '@mui/icons-material/Window';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import Iframe from 'react-iframe'
import { Avatar } from "@material-tailwind/react";
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction'; 
import Paper from '@mui/material/Paper';
 import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ContactMailIcon from '@mui/icons-material/ContactMail';


import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem, 
} from "@material-tailwind/react";

import React from "react";
import {
  Drawer,
  Button,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemPrefix,
  ListItemSuffix,
  Chip,
  Card,
} from "@material-tailwind/react"; 

function refreshMessages() {
  const getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max));

  return Array.from(new Array(50)).map(
    () => messageExamples[getRandomInt(messageExamples.length)],
  );
}
export default function Navbarsection() {
  
  const [open, setOpen] = React.useState(false);
  const openDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);
  const [value, setValue] = React.useState('recents');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const ref = React.useRef();
    
  return (
    <> 

   {/* Navigation Bottom Bar Menu   */} 
 
 
  <Box className="block md:hidden sticky top-0 z-[50] " sx={{ pb: 0 }} ref={ref}>
      
      <CssBaseline />
       
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, paddingLeft: 1,paddingRight: 1, }} elevation={5}>
        
        <BottomNavigation
          showLabels
          value={value} onChange={handleChange}
        >
           <BottomNavigationAction label="Home" value="Home" icon={<HomeIcon />}  href='https://www.sitekitpro.com/'/>
            

           <BottomNavigationAction  onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }}  href='https://www.sitekitpro.com/Category/'  label="Category"  icon={<WindowIcon />} />  


        <BottomNavigationAction onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} href='https://www.sitekitpro.com/Newlatestupdates/'  label="Latest"
          icon={<TipsAndUpdatesIcon />} />  

        
<BottomNavigationAction onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }}  href='https://www.m.sitekitpro.com/my-account/'  label="Account"  icon={<AccountCircleIcon />} /> 
 
        </BottomNavigation>
      </Paper>
  
    </Box>
 
     
    <nav aria-label="Global" className="border-b items-center justify-between m-auto top-0 animated p-1
 bg-opacity-95 bg-black 
 
    block sticky top-0 z-[50] ">
    
    <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
      <div className="flex h-16 items-center justify-between">
{/* Dextop logo  */}

        <div className="hidden md:block md:items-center md:gap-2 text-slate-200 mr-[12px]">
         
        <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} className="hover:text-green-400 block text-white mt-0" to="/">
   <span className="sr-only"> Home </span>
   <img src="./assets/logo/whitelogo.png" alt="" className="self-center w-31 h-12 mx-1 mr-[-22px]" /> 
    </Link>
          
        </div>


{/* Mobile Menu Button   */}
<div className="flex ms-[-9px] block md:hidden">   
        <a>  <Button onClick={openDrawer} className="mr-[-25px] text-white bg-black rounded p-2 text-black-50 transition hover:text-gray-600/75 mb-0" type="button" > <svg class="w-5 h-5 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h14M1 6h14M1 11h7"/>
  </svg> </Button> </a>
         
                 </div>

{/* Mobile logo  */}

        <div className="block md:hidden  md:items-center md:gap-2 text-slate-200 ms-[12px]">
        <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} className="hover:text-green-400 block text-white mt-0" to="/">
     
            <span className="sr-only"> Home </span>
            <img src="./assets/logo/whitelogo.png" alt="" className="self-center w-54 h-9 mx-5 mr-[0px]" />
         </Link>
        </div>
 

{/* Search Button Mobile  Mobile   */}
 
<div className=" ml-[46px] flex block md:hidden">
       
<Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }}  to="/searchanything" > 
  <a className=" rounded-md ms-[8] " >   <button type="button" className="ml-[5px] text-black bg-white hover:text-blue-800 hover:bg-teal focus:ring-4 focus:outline-none focus:ring-white/50 font-medium rounded-lg text-sm px-3 py-2 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 me-2 mr-[-3f6px]">

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-blue-800 hover:text-black w-6 h-6">
<path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clip-rule="evenodd" />
</svg> 

Search   

</button>  

</a> </Link>

    </div> 
    
{/*  */}

        {/* Only Dextop  */}
  
        {/* Dextop 2nd Menuline   */}

        <div className="ml-[1px] hidden md:block ">
          <nav aria-label="Global">
            <ul className="flex items-left gap-9 text-sm ml-[52px]">
              <li>
              <div class="ml-[-96px] hidden sm:flex justify-items-end ">
        <div class=""> <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }}  to="/" >   <a className="self-end rounded-md ms-8 " >   <button type="button" className="text-black bg-white hover:text-blue-800 hover:bg-teal focus:ring-4 focus:outline-none focus:ring-white/50 font-medium rounded-lg text-sm px-2 py-1 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 me-2 mr-[-36px]">

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-blue-800 hover:text-black w-6 h-6">
<path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
</svg> 
Home    
</button>  

</a> </Link> </div> 
    </div>
              </li>
              <li>
              <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} className="hover:text-green-400 block text-white mt-2" to="/about">
  About 
    </Link>
              </li>


            <li> <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} className="hover:text-green-400 block text-white mt-2" to="/Sitekitthemes">
  Sitekit Themes  
    </Link>  </li>


              <li>
            <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} className="hover:text-green-400 block text-white mt-2" to="/Plugins">
  Plugins 
    </Link> 
              </li>
 
              <li>
            <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} className="hover:text-green-400 block text-white mt-2" to="/category">
Category
    </Link> 
              </li>

              <li>
            <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} className="hover:text-green-400 block text-white mt-2" to="/Whyus">
  Why Us?
    </Link> 
              </li>
 
              <li>
                
              <div className="hidden sm:flex ">
   <a className="rounded-md ms-"  >
           
<Menu allowHover>
      <MenuHandler>
      <button type="button" className="mt-2 hover:text-green-400 text-white hover:bg-teal  font-medium rounded-lg text-sm text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 "> 
More 
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5" />
</svg>

</button> 
 
      </MenuHandler> 
      <MenuList  className="bg-orange-200 mt-3">
      <MenuItem className="flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
</svg>

 
          <Typography variant="small" className="font-medium">
          <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} className="hover:text-blue-800 block text-black mt-0" to="/faq">
 FAQ
    </Link> 
     
           </Typography>
        </MenuItem>

        <MenuItem className="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
</svg>

 
          <Typography variant="small" className="font-medium">
          <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} className="hover:text-blue-800 block text-black mt-0" to="/blog">
 Our Blog
    </Link> 
     
           </Typography>
        </MenuItem>

        <MenuItem className="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z" />
</svg>

 
          <Typography variant="small" className="font-medium">
          <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} className="hover:text-blue-800 block text-black mt-0" to="/jobs">
 Carrer / Jobs Apply
    </Link> 
 
           </Typography>
        </MenuItem>


        <MenuItem className="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" />
</svg>


 
          <Typography variant="small" className="font-medium">
          <a href="mailto:support@sitekitpro.com" className="hover:text-blue-800 text-[14px] text-black"  > Support | Mail  </a>
          </Typography>
        </MenuItem>


        </MenuList>
        
        
        </Menu>
        
        
        </a>
        
        
        </div>   
              </li>

             
            </ul>
          </nav>

        </div>

<div> </div>

 {/* Search  Start  Dextop  */}


        <div class="ml-[-96px] hidden sm:flex justify-items-end ">
        <div class=""> <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }}  to="/searchanything" >   <a className="self-end rounded-md ms-8 " >   <button type="button" className="text-black bg-white hover:text-blue-800 hover:bg-teal focus:ring-4 focus:outline-none focus:ring-white/50 font-medium rounded-lg text-sm px-3 py-1 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 me-2 mr-[-36px]">

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-blue-800 hover:text-black w-6 h-6">
<path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clip-rule="evenodd" />
</svg>  
Search  
</button>  

</a> </Link> </div> 
    </div>
     
     {/* Search  End  Dextop  */}


     {/* Account Section  Dextop  */}

<div className="ml-[-7px] flex hidden sm:flex ">
   <a className="self-end rounded-md ms-8 " >
  
<Menu allowHover>
      <MenuHandler>
      <button type="button" className="text-black bg-white hover:text-blue-800 hover:bg-teal focus:ring-4 focus:outline-none focus:ring-white/50 font-medium rounded-lg text-sm px-3 py-1 text-center inline-flex items-center dark:hover:bg-[#050708]/40 dark:focus:ring-gray-600 me-2 mr-[-36px]">

       
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
  <path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clip-rule="evenodd" />
</svg>
 
  Account  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
<path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />

</svg>

</button> 
      </MenuHandler>
      
      <MenuList className='bg-orange-200' >
      <MenuItem><br></br>
      <a onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }}  href='https://www.m.sitekitpro.com/my-account/' >  <Button
           size="lg"
           color="white"
           className="pt-3 pb-3 hover:scale-[1.02] focus:scale-[1] active:scale-80"
           ripple={false}
           fullWidth={true}
         >
        <Avatar  size="sm" src="https://ik.imagekit.io/sitekitpro/assets/icons/account.png?updatedAt=1743874052026" alt="avatar" className="pr-1 ml-1" />  My Account
         </Button></a>
         </MenuItem>
      <MenuItem className="flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
</svg>

 
          <Typography variant="small" className="font-medium">
          <a href="https://www.m.sitekitpro.com/my-account/orders/" className="hover:text-blue-800 text-[15px] text-black"  >  Downloads / Orders   </a>
          </Typography>
        </MenuItem>

        <MenuItem className="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
</svg>

 
          <Typography variant="small" className="font-medium">
          <a  href="https://www.m.sitekitpro.com/my-account/edit-account/" className="hover:text-blue-800 text-[15px] text-black"  > Account Details   </a>
          </Typography>
        </MenuItem>
 
      </MenuList>
    </Menu> 
              </a>
            </div>
  
           {/* End Account Section Dextop  */}
  
 
  {/* Only Mobile  */}

        <div className="flex items-center gap-[-4px]">
  
     {/* Menu Button Mobile  Mobile   */}




                 {/* DrawerMenu Mobile   */}

                 <React.Fragment>
      

      <Drawer className="bg-black z-50"  open={open} onClose={closeDrawer}>
        <div className="mb-2 flex items-center justify-between p-4">

          
          <Typography variant="h5" className="text-white hover:text-white	text-[13px]" color="blue-gray">
            Menu View
          </Typography>
          <IconButton variant="text" className="text-white bg-red-500" onClick={closeDrawer}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="text-white hover:text-white h-5 w-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </IconButton>
        </div>

        <List className="mt-[-15px] p-0">
          {/* Home Section  */}
        

       {/* 1st Home */}
       
       <a href="/">
        <ListItem href="/Search" className="group rounded-none py-1.5 px-3 text-sm font-normal  text-white  hover:text-blue-200
         focus:text-pink-400 ">
          <ListItemPrefix> 

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
          <path fill-rule="evenodd" d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6 2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2 6-6Z" clip-rule="evenodd"/>
</svg>

          </ListItemPrefix>
      Home 
        </ListItem></a>


   {/* Services  Section  */}
      
   <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} className='hover:scale-[1.02]' to="/Newlatestupdates"  
> 
           <ListItem className="rounded-none py-1.5 px-3 text-sm font-normal text-white hover:bg-blue-500 hover:text-white focus:bg-blue-500 focus:text-white">
          <ListItemPrefix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
</svg>


  </ListItemPrefix> 
  <p className="text-[14px] mr-[50px]" > Latest Updates   </p>

          <ListItemSuffix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-8 mr-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /> 
</svg>

          </ListItemSuffix>  <Chip
              value="New"
              variant="ghost"
              size="sm"
              className="rounded-full px-2 py-1 text-white text-xs bg-orange-400 group-hover:bg-orange-400 group-hover:text-white"
            />
        </ListItem> </Link>



       {/* Sitekitpro  */}


       <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} to="/Sitekitthemes"  >
  
   
        <ListItem href="/Search" className="group rounded-none py-1.5 px-3 text-sm font-normal  text-white  hover:text-blue-200
         focus:text-pink-400 ">
          <ListItemPrefix>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
   
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25" />

</svg>

          </ListItemPrefix>
       SitekitPro | Themes 
          <ListItemSuffix>
            <Chip
              value="Category"
              variant="ghost"
              size="sm"
              className="rounded-full px-2 py-1 text-white text-xs bg-orange-400 group-hover:bg-orange-400 group-hover:text-white"
            />
          </ListItemSuffix>
        </ListItem></Link>



         {/* Sitekitpro  */}


       <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} to="/Plugins"  >
  
   
        <ListItem href="/Search" className="group rounded-none py-1.5 px-3 text-sm font-normal  text-white  hover:text-blue-200
         focus:text-pink-400 ">
          <ListItemPrefix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
</svg>


          </ListItemPrefix>
       Plugins 
          <ListItemSuffix>
            <Chip
              value="Category"
              variant="ghost"
              size="sm"
              className="rounded-full px-2 py-1 text-white text-xs bg-orange-400 group-hover:bg-orange-400 group-hover:text-white"
            />
          </ListItemSuffix>
        </ListItem></Link>
     
{/* About Section  */}
<Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} className='hover:scale-[1.02]' to="/About"  
>
 <ListItem className="rounded-none py-1.5 px-3 text-sm font-normal text-white hover:bg-blue-500 hover:text-white focus:bg-blue-500 focus:text-white">
          <ListItemPrefix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
</svg>

  </ListItemPrefix> <p className="text-[14px] mr-[50px]" > About Us   </p>

          <ListItemSuffix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-8 mr-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
</svg>

          </ListItemSuffix> 
        </ListItem></Link>

       
       {/* Services  Section  */}
      
       <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} className='hover:scale-[1.02]' to="/whyus"  
> 
           <ListItem className="rounded-none py-1.5 px-3 text-sm font-normal text-white hover:bg-blue-500 hover:text-white focus:bg-blue-500 focus:text-white">
          <ListItemPrefix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
</svg>


  </ListItemPrefix> 
  <p className="text-[14px] mr-[50px]" > Why Us?   </p>

          <ListItemSuffix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-8 mr-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
</svg>

          </ListItemSuffix> 
        </ListItem> </Link>

     {/* Blog  Section  */}

     <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} className='hover:scale-[1.02]' to="/blog"  
>  
           <ListItem className="rounded-none py-1.5 px-3 text-sm font-normal text-white hover:bg-blue-500 hover:text-white focus:bg-blue-500 focus:text-white">
          <ListItemPrefix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
</svg>


  </ListItemPrefix> <p className="text-[14px] mr-[50px]" > Blogs </p>

          <ListItemSuffix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-8 mr-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
</svg>

          </ListItemSuffix> 
        </ListItem></Link>

     {/* Jobs   Section  */}
    
     <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} className='hover:scale-[1.02]' to="/jobs"  
>


           <ListItem className="rounded-none py-1.5 px-3 text-sm font-normal text-white hover:bg-blue-500 hover:text-white focus:bg-blue-500 focus:text-white">
          <ListItemPrefix>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
  <path fill-rule="evenodd" d="M7.5 5.25a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0 1 12 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 0 1 7.5 5.455V5.25Zm7.5 0v.09a49.488 49.488 0 0 0-6 0v-.09a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5Zm-3 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" />
  <path d="M3 18.4v-2.796a4.3 4.3 0 0 0 .713.31A26.226 26.226 0 0 0 12 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 0 1-6.477-.427C4.047 21.128 3 19.852 3 18.4Z" />
</svg>


  </ListItemPrefix> <p className="text-[14px] mr-[50px]" > Jobs Apply | Career  </p>

          <ListItemSuffix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-8 mr-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
</svg>

          </ListItemSuffix> 
        </ListItem></Link> 

        
       
      </List>

      {/* End Menu Section First  */}

      <a onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }}  href='https://www.m.sitekitpro.com/my-account/' > 
 <Button className="hover:bg-orange-300 bg-white mt-2 ml-5" size="sm">
        <ListItem className="rounded-none py-1.5 px-3 text-sm font-normal  text-black hover:bg-white hover:text-black focus:bg-white focus:text-black">
          <ListItemPrefix>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
</svg>


  </ListItemPrefix> <p  className="text-[14px] mr-[12px]" > My Account    </p>

  <ListItemSuffix>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25" />
</svg>


          </ListItemSuffix>
        </ListItem> 
        </Button></a>
      </Drawer>
    </React.Fragment> 
      
 
        </div>

      </div>
    </div>
 
    <script src="../path/to/flowbite/dist/flowbite.js"></script> 
    <script src="https://cdn.tailwindcss.com"></script>  
</nav>
    </>
  )
}const messageExamples = [
  {
    primary: 'Brunch this week?',
    secondary: "I'll be in the neighbourhood this week. Let's grab a bite to eat",
    person: '/static/images/avatar/5.jpg',
  },
  {
    primary: 'Birthday Gift',
    secondary: `Do you have a suggestion for a good present for John on his work
      anniversary. I am really confused & would love your thoughts on it.`,
    person: '/static/images/avatar/1.jpg',
  },
  {
    primary: 'Recipe to try',
    secondary: 'I am try out this new BBQ recipe, I think this might be amazing',
    person: '/static/images/avatar/2.jpg',
  },
  {
    primary: 'Yes!',
    secondary: 'I have the tickets to the ReactConf for this year.',
    person: '/static/images/avatar/3.jpg',
  },
  {
    primary: "Doctor's Appointment",
    secondary: 'My appointment for the doctor was rescheduled for next Saturday.',
    person: '/static/images/avatar/4.jpg',
  },
  {
    primary: 'Discussion',
    secondary: `Menus that are generated by the bottom app bar (such as a bottom
      navigation drawer or overflow menu) open as bottom sheets at a higher elevation
      than the bar.`,
    person: '/static/images/avatar/5.jpg',
  },
  {
    primary: 'Summer BBQ',
    secondary: `Who wants to have a cookout this weekend? I just got some furniture
      for my backyard and would love to fire up the grill.`,
    person: '/static/images/avatar/1.jpg',
  },
];

 
 